import { all, put, takeEvery, takeLeading } from 'redux-saga/effects';
import { api, commonApiSaga } from 'redux/helpers/api';
import history from 'providers/history';
import { takeLeadingPerKey } from 'redux/helpers/saga';
import { authActions } from 'redux/auth';
import types from './types';

// Pinned pages in the Hub come from the auth user
function* refreshAuthUser() {
  yield put(authActions.getAuthUser());
}

export default function* pageSagas() {
  yield all([
    takeLeading(types.getPages, commonApiSaga, { apiFn: api.pages.index, workspaceId: true }),
    takeLeading(types.delete, commonApiSaga, { apiFn: api.pages.delete, workspaceId: true, successMessage: 'page.deleted' }),
    takeLeading(types.store, commonApiSaga, { apiFn: api.pages.store, workspaceId: true, successMessage: 'page.stored' }),
    takeLeading(types.patch, commonApiSaga, { apiFn: api.pages.patch, workspaceId: true, successMessage: 'page.updated', onSuccess: refreshAuthUser }),
    takeLeading(types.update, commonApiSaga, { apiFn: api.pages.update, workspaceId: true, successMessage: 'page.updated' }),
    takeLeadingPerKey(types.getPage, commonApiSaga, ({ pageId }) => pageId, { apiFn: api.pages.show, workspaceId: true, onFailure: () => history.push('/') }),

    takeLeading(types.getKnowledgeHub, commonApiSaga, { apiFn: api.pages.getKnowledgeHub, workspaceId: true }),

    takeLeading(types.getCategories, commonApiSaga, { apiFn: api.pages.categories.index, workspaceId: true }),
    takeEvery(types.createCategory, commonApiSaga, { apiFn: api.pages.categories.create, workspaceId: true }),
    takeEvery(types.updateCategory, commonApiSaga, { apiFn: api.pages.categories.update, workspaceId: true }),
    takeEvery(types.deleteCategory, commonApiSaga, { apiFn: api.pages.categories.delete, workspaceId: true }),
  ]);
}
